import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import SingleSelect from "../../../../Components/Select/SingleSelect";
import { useFilters } from "./useFilters";

import {
  filterContainerStyles,
  filtersRowStyles,
  filtersGroupStyles,
  selectStyles,
} from "./styles";

export const Filters = ({
  visosImones = [],
  filters = {},
  years = [],
  setYear,
  currentYear,
  setFilter,
  setFilterMain,
  filtersMain,
  user,
  isLoading,
  isAdmin, // Accept isAdmin prop
}) => {
  const { t } = useTranslation();
  // Removed internal admin check, will use isAdmin prop

  // Debugging info removed

  const { handleYearChange, handleCompanyChange, handleFormTypeChange } =
    useFilters({
      t,
      filtersMain,
      setFilterMain,
      user,
      setYear,
    });

  // Optimizuotas formų tipų gavimas - naudojame useMemo kad išvengti nereikalingų klairų
  const formTypeOptions = useMemo(
    () => t("pildytojuTipai2", { returnObjects: true }) || [],
    [t]
  );

  // Optimizuotas įmonių sąrašo paruosimas su useMemo
  const { companyOptions, companyOptionsText } = useMemo(() => {
    // Patikriname ar sąrašas validus ir neturi dublikatų
    const companies = Array.isArray(visosImones) && visosImones.length > 0 ? visosImones : [];

    // Sukuriame options su reikšmėmis ir tekstu
    return {
      companyOptions: ["all", ...companies],
      companyOptionsText: [t("rodytiVisus"), ...companies],
    };
  }, [visosImones, t]);

  return (
    <Box sx={filterContainerStyles}>
      <Box sx={filtersRowStyles}>
        <Box sx={filtersGroupStyles}>
          {/* Form Type Selection */}
          <SingleSelect
            label={t("pasirinkti")}
            value={filtersMain.kasPildo || ""}
            onChange={handleFormTypeChange}
            options={formTypeOptions}
            sx={selectStyles}
            sx0={{ minWidth: "unset" }}
          />

          {/* Year Selection - moved before company selection */}
          {years.length > 0 && (
            <SingleSelect
              label={t("metai")}
              value={currentYear || ""}
              onChange={handleYearChange}
              options={years}
              optionsText={years.map((y) => y.toString())}
              disabled={isLoading || !filtersMain.kasPildo}
              sx={selectStyles}
              sx0={{ minWidth: "unset" }}
            />
          )}

          {/* Company Selection - now after year selection */}
          {/* Use the passed isAdmin prop for conditional rendering */}
          {isAdmin ? (
            <>
              <SingleSelect
                label={t("imonesLabel")}
                value={filtersMain.imonesPavadinimas || "all"}
                onChange={handleCompanyChange}
                options={companyOptions}
                optionsText={companyOptionsText}
                disabled={isLoading || !filtersMain.kasPildo || companyOptions.length <= 1}
                sx={selectStyles}
                sx0={{ minWidth: "unset" }}
              />
            </>
          ) : (
            <>{/* Admin info removed */}</>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Filters;
